import { render, staticRenderFns } from "./DialogTemplateEmailTest.vue?vue&type=template&id=f5ca8834&"
import script from "./DialogTemplateEmailTest.vue?vue&type=script&lang=js&"
export * from "./DialogTemplateEmailTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports